import React from "react";
import Progress from "../../../components/progress";
import {  MdCheckCircle, MdOutlineError, MdCancel } from "react-icons/md";

import {
  createColumnHelper,
  SortingState
} from "@tanstack/react-table";
import { formatTime, timeDiffer } from "../../../utils/helper";


const columnHelper = createColumnHelper();

export const FeatureTableColumns = [
    columnHelper.accessor("hostname", {
      id: "hostname",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Host Name</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("pageName", {
      id: "pageName",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Page Name</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("url", {
      id: "url",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">URL</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("userStatus", {
      id: "userStatus",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Paid User Clicks</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().totalPaidUsers.length}
        </p>
      ),
    }),
    columnHelper.accessor("userStatus", {
      id: "userStatus",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Free Trails Users Clicks</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().totalFreeTrial.length}
        </p>
      ),
    }),
    columnHelper.accessor("totalUsers", {
      id: "totalUsers",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          No Of Users Visited
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
         ),
    }),
    columnHelper.accessor("totalTimeSpent", {
      id: "totalTimeSpent",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total Time Spent</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {formatTime(info.getValue())}
        </p>
      ),
    }),
    columnHelper.accessor("avgTimeSpent", {
      id: "avgTimeSpent",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Spent Per Day/Week/Month
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <p className="text-sm font-bold text-navy-700 dark:text-white">
            {formatTime(info.getValue())}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("lastTimeUsed", {
        id: "lastTimeUsed",
        header: () => (
          <p className="text-sm font-bold text-gray-600 dark:text-white">
            Last Time Used
          </p>
        ),
        cell: (info) => (
          <div className="flex items-center">
            <p className="text-sm font-bold text-navy-700 dark:text-white">
              {timeDiffer(info.getValue())}
              <span className="text-sm px-1">ago</span>
            </p>
          </div>
        ),
      }),
      columnHelper.accessor("totalEvents", {
        id: "totalEvents",
        header: () => (
          <p className="text-sm font-bold text-gray-600 dark:text-white">
            Total Events
          </p>
        ),
        cell: (info) => (
          <div className="flex items-center">
            <p className="text-sm font-bold text-navy-700 dark:text-white">
              {info.getValue().length}
            </p>
          </div>
        ),
      })
  ]; 

  export const CustomerTableColumns = [
    columnHelper.accessor("userName", {
      id: "userName",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">User Name</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("userEmail", {
      id: "userEmail",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">User Email</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("paidFreeTrailUser", {
      id: "paidFreeTrailUser",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">User Status</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("companyIndividual", {
      id: "companyIndividual",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Company Individual</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    
    columnHelper.accessor("totalPagesExplored", {
      id: "totalPagesExplored",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Total Pages Explored
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <Progress width={`w-[${108}px]`} value={info.getValue()} />
          <p className="text-sm font-bold text-gray-600 dark:text-white">{info.getValue().length}</p>
        </div>
      ),
    }),
    columnHelper.accessor("totalEventsClicked", {
      id: "totalEventsClicked",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Total Events Clicks</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().length}
        </p>
      ),
    }),
    columnHelper.accessor("averageTimeSpentOnWebsite", {
      id: "averageTimeSpentOnWebsite",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Average TimeSpent On Website
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          
          <p className="text-sm font-bold text-navy-700 dark:text-white">
            {formatTime(info.getValue())}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("lastActivity", {
        id: "lastActivity",
        header: () => (
          <p className="text-sm font-bold text-gray-600 dark:text-white">
            Last Activity
          </p>
        ),
        cell: (info) => (
          <div className="flex items-center">
            
            <p className="text-sm font-bold text-navy-700 dark:text-white">
              {timeDiffer(info.getValue())}
              <span className=" px-1 text-sm"> ago</span>
            </p>
          </div>
        ),
      })
  ]; 